import { base } from "viem/chains";

export const ACTIVE_CHAIN = base;

/**
 * Public Base RPC endpoints, tried in order. `mainnet.base.org` rate-limits
 * aggressively per-IP, so we put it last and lean on community endpoints
 * for the bulk of read traffic. All endpoints expose multicall3.
 */
export const RPC_URLS: readonly string[] = [
  "https://base.publicnode.com",
  "https://base.llamarpc.com",
  "https://base.drpc.org",
  "https://base.blockpi.network/v1/rpc/public",
  "https://mainnet.base.org",
] as const;

// Kept for backwards compatibility with any imports that still want a single
// URL; prefer RPC_URLS via the fallback transport in clients.ts.
export const RPC_URL = RPC_URLS[0];
